import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';

@Component({
  selector: 'job-category-maintenance',
  templateUrl: './job-category-maintenance.component.html',
  styleUrls: ['./job-category-maintenance.component.css']
})
export class JobCategoryMaintenanceComponent implements OnInit, LeaveConfirmation {

  private moduleId: string = 'BMM020';
  public moduleName: string = this._jDS.data.moduleList.find((a: any) => a.moduleId === this.moduleId)?.moduleDesc?.toUpperCase() ?? "";

  constructor(
    private fb: FormBuilder,
    private _matDialog: MatDialog,
    private _api: APICallService,
    public _formService: FormService,
    private _jDS: JsonDataService,
    private _userDetailService: UserDetailsService,
    private _securityService: SecurityService) {
      this.userIdLoggedIn = this._userDetailService.userId ?? "";
     }

  ngOnInit(): void {
    this.getData.jobCategory();
  }

  canDeactivate(): boolean | Observable<boolean> {
    if(this.tempData!='') {
      return false;
    } else {
      return true;
    }
  }

  public btns = {
    jobCategory: {
      updateDisabled: true,
      deleteDisabled: true,
      saveDisabled: true,
      addDisabled: true,
    },
  }

  public selections = {
    activeTypes: [
      { cd: 'A', name: 'Yes' },
      { cd: 'I', name: 'No' },
    ],
    highRiskTypes: [
      { cd: 'Y', name: 'Yes' },
      { cd: 'N', name: 'No' },
    ]
  }

  public showForm: boolean = true;

  private rowData: any;
  private tempDataRow: any;
  private errorMessage: string = "";
  private userIdLoggedIn: string;
  private tempData: any = [];

  public forms = {
    jobCategoryForm: this.fb.group({
      jobCategoryCd: [null],
      jobCategoryCdDisp: [{ value: '', disabled: 'true' }],
      jobCategoryDesc: [null, [Validators.required, Validators.maxLength(30), this.checkDuplicateJobCategoryDesc(), this.noWhiteSpaceCheck()]],
      activeTag: ['A', [Validators.required]],
      highRiskTag: ['N', [Validators.required]],
      bmCode: [null, [Validators.required, Validators.maxLength(8), this.noWhiteSpaceCheck()]],
      bmShortDesc: [null, [Validators.maxLength(10)]],
      remarks: [null, [Validators.maxLength(4000)]],
      userID: [{ value: '', disabled: 'true' }],
      lastUserUpdate: [{ value: '', disabled: 'true' }],
    }),
    resetJobCategoryForm: () => {
      this.forms.jobCategoryForm.reset();
      this.forms.jobCategoryForm.patchValue({
        activeTag: 'A',
        highRiskTag: 'N'
      });
      this.btns.jobCategory.updateDisabled = this.btns.jobCategory.deleteDisabled = true;
      this._formService.hideFormMsg("job-category-error-message");
      // this.rowData = null;
    }
  }

  private jobCategoryFormManipulate = {
    dbToForm: (data: any) => {
      return {
        jobCategoryCd: data.CATEGORY_CD,
        jobCategoryCdDisp: data.CATEGORY_CD_DISP,
        jobCategoryDesc: data.CATEGORY_DESC,
        activeTag: data.ACTIVE_TAG,
        highRiskTag: data.HIGH_RISK_TAG,
        bmCode: data.BM_CODE,
        bmShortDesc: data.BM_SHORT_DESC,
        remarks: data.REMARKS,
        userID: data.USER_ID,
        lastUserUpdate: data.LAST_UPDATE,
      };
    },
    formToDb: (data: any, mode: any) => {
      return {
        CATEGORY_CD: data.jobCategoryCd,
        CATEGORY_CD_DISP: data.jobCategoryCd?.toString().padStart(2, 0) ?? null,
        CATEGORY_DESC: data.jobCategoryDesc.trim(),
        ACTIVE_TAG: data.activeTag,
        HIGH_RISK_TAG: data.highRiskTag,
        BM_CODE: data.bmCode,
        BM_SHORT_DESC: data.bmShortDesc,
        REMARKS: data.remarks,
        USER_ID: this.userIdLoggedIn,
        LAST_UPDATE: null,
        MODE: mode
      };
    },
  }

  public jobCategoryTblConfig = {
    cols: [
      {
        key: "CATEGORY_CD_DISP",
        header: "Category Code",
        dataType: "string",
        width: '20%'
      },
      {
        key: "CATEGORY_DESC",
        header: "Job Category",
        dataType: "string"
      },
      {
        key: "HIGH_RISK_TAG",
        header: "High Risk",
        dataType: "string",
        width: '15%'
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '64px'
      }
    ],
    tblData: [] as any[],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }

  private getData = {
    jobCategory: () => {
      try {
        this.jobCategoryTblConfig.tblData = [];
        this.jobCategoryTblConfig.loading = true;
        this._jDS.contorlLoading(true);
        this._api.getJobCategory({
          moduleId: this.moduleId,
          userId: this._userDetailService.userId,
          type: "MODULE"
        }).subscribe({
          next: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {
              this._securityService.hasValidCsrfToken(data, () => {
                let content = JSON.parse(this._jDS.decrypt(data.response));
                this._jDS.contorlLoading(false);
                this.jobCategoryTblConfig.tblData = content.data;
                this.btns.jobCategory.addDisabled = false;
                this.jobCategoryTblConfig.loading = false;
              });
            });
          },
          error: (error: any) => {
            this.jobCategoryTblConfig.loading = false;
            this._jDS.contorlLoading(false);
          }
        });
      }
      catch (e) {
        console.error(e);
      }
    }
  }

  public onRowClick(ev: any) {
    try {
      ev.update = true;
      this.rowData = ev;
      this.populateFormFromTable();
    }
    catch (e) {
      this.forms.resetJobCategoryForm();
      this.rowData = null;
    }
  }

  private populateFormFromTable() {
    try {
      let data = this.rowData;
      this.btns.jobCategory.updateDisabled = !data.update;
      this.btns.jobCategory.deleteDisabled = !data.temp;
      this.tempDataRow = !data.temp;
      this.forms.jobCategoryForm.patchValue(this.jobCategoryFormManipulate.dbToForm(data));
    }
    catch (e) {
      console.error(e);
    }
  }

  public onAdd() {
    try {
      this._formService.hideFormMsg("job-category-error-message");
      if (this.forms.jobCategoryForm.valid) {
        let rowToBeAdded: { [key: string]: any } = this.jobCategoryFormManipulate.formToDb(this.forms.jobCategoryForm.value, 'I');
        rowToBeAdded.temp = true;
        this.tempData.push(rowToBeAdded);
        this.jobCategoryTblConfig.tblData = [rowToBeAdded, ...this.jobCategoryTblConfig.tblData];
        this.forms.resetJobCategoryForm();
        this.btns.jobCategory.saveDisabled = false;
      }
      else {
        this.showErrorValidator.jobCategory();
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  public onDelete() {
    try {
      let clickData = this.rowData;
      this.jobCategoryTblConfig.tblData = this.jobCategoryTblConfig.tblData.filter((d: any) => {
        return d !== this.rowData;
      });
      this.tempData = this.tempData.filter(
        function(e: any) {
          return e.CATEGORY_DESC != clickData.CATEGORY_DESC;
        }
      );
      this.forms.resetJobCategoryForm();
    }
    catch (e) {
      console.error(e);
    }
  }

  public onUpdate() {
    try {
      this._formService.hideFormMsg("job-category-error-message");
      
      if (this.forms.jobCategoryForm.valid) {
        let clickData = this.rowData;
        let toBeUpdatedIndex = this.jobCategoryTblConfig.tblData.indexOf(this.rowData);
        let jobCategoryCdRowValue = this.rowData.CATEGORY_CD;
        let rowToBeUpdated: { [key: string]: any } = this.jobCategoryFormManipulate.formToDb(this.forms.jobCategoryForm.value, 'U');
        let tempInsertChecker = this.tempData.find(
          (j: { CATEGORY_DESC: any; }) => j.CATEGORY_DESC == clickData.CATEGORY_DESC && clickData.MODE == 'I');
        let tempUpdateChecker = this.tempData.find(
          (j: { CATEGORY_DESC: any; }) => j.CATEGORY_DESC == clickData.CATEGORY_DESC && clickData.MODE == 'U');
        if (this.rowData.temp) {
          rowToBeUpdated.temp = true;
        }
        else {
          rowToBeUpdated.onDbButUpdatedTemp = true;
          rowToBeUpdated.CATEGORY_CD = jobCategoryCdRowValue;
        }

        if (tempInsertChecker!=null && tempInsertChecker!='') {
          //tempInsertChecker = rowToBeUpdated;
          tempInsertChecker.CATEGORY_DESC = rowToBeUpdated.CATEGORY_DESC;
          tempInsertChecker.ACTIVE_TAG = rowToBeUpdated.ACTIVE_TAG;
          tempInsertChecker.HIGH_RISK_TAG = rowToBeUpdated.HIGH_RISK_TAG;
          tempInsertChecker.BM_CODE = rowToBeUpdated.BM_CODE;
          tempInsertChecker.BM_SHORT_DESC = rowToBeUpdated.BM_SHORT_DESC;
          tempInsertChecker.REMARKS = rowToBeUpdated.REMARKS;
          tempInsertChecker.USER_ID = rowToBeUpdated.USER_ID;
          tempInsertChecker.MODE = 'I';
          rowToBeUpdated.MODE = 'I';
        }
        else if (tempUpdateChecker!=null && tempUpdateChecker!='') {
          tempUpdateChecker.CATEGORY_DESC = rowToBeUpdated.CATEGORY_DESC;
          tempUpdateChecker.ACTIVE_TAG = rowToBeUpdated.ACTIVE_TAG;
          tempUpdateChecker.HIGH_RISK_TAG = rowToBeUpdated.HIGH_RISK_TAG;
          tempUpdateChecker.BM_CODE = rowToBeUpdated.BM_CODE;
          tempUpdateChecker.BM_SHORT_DESC = rowToBeUpdated.BM_SHORT_DESC;
          tempUpdateChecker.REMARKS = rowToBeUpdated.REMARKS;
          tempUpdateChecker.USER_ID = rowToBeUpdated.USER_ID;
          tempUpdateChecker.MODE = 'U';
        }
        else { 
          this.tempData.push(rowToBeUpdated);
        }
        this.forms.resetJobCategoryForm();
        this.jobCategoryTblConfig.tblData[toBeUpdatedIndex] = rowToBeUpdated;
        this.btns.jobCategory.saveDisabled = false;
        this.jobCategoryTblConfig.tblData = [... this.jobCategoryTblConfig.tblData];
      }
      else {
        this.showErrorValidator.jobCategory();
      }
    }
    catch (e) {
      console.error(e);
    }
  }

  public onSave() {
    try {
      this.btns.jobCategory.saveDisabled = true;
      this.showForm = false;
      this._formService.showFormLoader(null, "job-category-maintenance-loading", "Saving.<br>Please wait ...", null, null);
      if (this.tempData.length > 0) {
        this._api.saveJobCategory(this.tempData).subscribe({
          next: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {
              this._securityService.hasValidCsrfToken(data, () => {
                if (data.status === 'SUCCESS') {
                  this.onComplete.jobCategory();
                }
                else {
                  this.onComplete.jobCategoryError();
                }
              });
            });
          },
          error: (data: any) => {
            this.onComplete.jobCategoryError();
          },
        });
      }
      else
        this.onComplete.jobCategory();
    }
    catch (e) {
      console.error(e);
    }
  }

  private onComplete = {
    jobCategory: () => {
      this.tempData = [];
      this.getData.jobCategory();
      this.btns.jobCategory.saveDisabled = true;
      this.showForm = true;
      this._formService.hideFormLoader("job-category-maintenance-loading");
      this.forms.resetJobCategoryForm();
      this.openDialog('SUCCESS', 'Job Category details successfully saved');
    },
    jobCategoryError: () => {
      this.showForm = true;
      this.btns.jobCategory.saveDisabled = false;
      this.openDialog('FAILED', 'Job Category details saving failed');
      this._formService.hideFormLoader("job-category-maintenance-loading");
    }
  }

  openDialog(title: any, message: any) {
    try {
      this.showForm = true;
      this._formService.hideFormLoader("job-category-maintenance-loading");
      this._matDialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
      console.error(e);
    }
  }

  checkDuplicateJobCategoryDesc(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim()?.toUpperCase();
      if (!value) return null;
      let hasDuplicate: boolean = this.jobCategoryTblConfig.tblData.filter((d: any) => {
        if (!this.rowData && this.btns.jobCategory.updateDisabled)
          return d.CATEGORY_DESC.trim().toUpperCase() === value;
        else
          return this.rowData.CATEGORY_DESC.trim().toUpperCase() !== value && d.CATEGORY_DESC.trim().toUpperCase() === value;
      }).length > 0 ? true : false;
      return hasDuplicate ? { hasDupe: true } : null;
    }
  }

  noWhiteSpaceCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { whitespace: true };
    }
  }

  public showErrorValidator = {
    jobCategory: () => {
      try {
        Object.keys(this.forms.jobCategoryForm.controls).forEach(key => {
          const controlErrors = this.forms.jobCategoryForm.get(key)?.errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              if (keyError == 'whitespace' && controlErrors[keyError] === true)
                this.errorMessage = "There are missing information. Please provide necessary information needed.";
              else if (keyError == 'hasDupe' && controlErrors[keyError] === true)
                this.errorMessage = "Job Category already exists. Please add a unique Job Category.";
              else if (keyError == 'required' && controlErrors[keyError] === true)
                this.errorMessage = "There are missing information. Please provide necessary information needed.";
            });
          }
        });
        this._formService.showFormMsg("job-category-error-message", this.errorMessage, "E");
        //this.openDialog('ERROR', this.errorMessage);
        setTimeout(()=>{                           
          this._formService.hideFormMsg("job-category-error-message");
        }, 10000);
      }
      catch (e) {
        console.error(e);
      }
    },
  }

}
